export const calculateDiscountedTuition = (
  tuition,
  scholarshipDiscount,
  promotionDiscount = 0
) => {
  const amount = Number(tuition);
  const scholarship = Number(scholarshipDiscount);
  const promotion = Number(promotionDiscount);
  if (
    !Number.isFinite(amount)
    || !Number.isFinite(scholarship)
    || !Number.isFinite(promotion)
  ) return 0;

  return Number((
    amount
    * ((100 - scholarship) / 100)
    * ((100 - promotion) / 100)
  ).toFixed(2));
};

export const findApplicablePromotion = (promotions, productId) => {
  if (!Array.isArray(promotions) || !productId) return null;

  return promotions
    .filter((promotion) => (
      Array.isArray(promotion.openpaySubscriptions)
      && promotion.openpaySubscriptions.some(
        (subscription) => String(subscription.productId) === String(productId)
      )
    ))
    .sort((first, second) => (
      Number(second.rawDisscount || 0) - Number(first.rawDisscount || 0)
      || new Date(first.finishDate) - new Date(second.finishDate)
    ))[0] || null;
};
